import type { TCommon, TGeneral } from '~/src/types/common'

export function logError(error?: Error | TGeneral | TCommon) {
  if (error) {
    const message = error instanceof Error ? error.message : error
    console.error({ error: message })
  }
}
